import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getConfig = () => axios.get(`${API}/config`).then((r) => r.data);

export const getWeather = (loc) =>
  axios
    .get(`${API}/weather`, {
      params: {
        lat: loc.lat,
        lon: loc.lon,
        name: loc.name || "",
        state: loc.state || "",
        country: loc.country || "",
      },
    })
    .then((r) => r.data);

export const geocode = (q) =>
  axios.get(`${API}/geocode`, { params: { q } }).then((r) => r.data.results);

export const reverseGeocode = (lat, lon) =>
  axios
    .get(`${API}/reverse-geocode`, { params: { lat, lon } })
    .then((r) => r.data.result);

export const popularCities = () =>
  axios.get(`${API}/cities/popular`).then((r) => r.data.results);

export const getRadarFrames = () => axios.get(`${API}/radar/frames`).then((r) => r.data);

export const owmTileUrl = (layer) => `${API}/tiles/owm/${layer}/{z}/{x}/{y}.png`;

export const getWindGrid = (params) => axios.get(`${API}/wind-grid`, { params }).then((r) => r.data);

export const getScalarGrid = (params) => axios.get(`${API}/scalar-grid`, { params }).then((r) => r.data);

export const getFires = (params) => axios.get(`${API}/fires`, { params }).then((r) => r.data);
